// Mintlify's Color palette, written back as its own <Color> tags.

import { escapePanelAttribute } from "../panel-markdown"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
	turndown: (input: string) => string
}

const hasType = (node: Node, type: string): boolean =>
	node.nodeName === "DIV" &&
	(node as HTMLElement).getAttribute("data-type") === type

export function colorItemMdx(item: HTMLElement): string {
	const name = item.getAttribute("data-name") ?? ""
	const light = item.getAttribute("data-value") ?? ""
	const dark = item.getAttribute("data-dark")
	const value =
		dark && dark !== light
			? `value={{ light: "${escapePanelAttribute(light)}", dark: "${escapePanelAttribute(dark)}" }}`
			: `value="${escapePanelAttribute(light)}"`
	return `<Color.Item name="${escapePanelAttribute(name)}" ${value} />`
}

// Turndown's server DOM has childNodes but no iterable `children`.
const children = (element: Element, type: string): HTMLElement[] =>
	Array.from(element.childNodes).filter((child): child is HTMLElement =>
		hasType(child, type),
	)

export function addColorMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("color", {
		filter: (node) => hasType(node, "color"),
		replacement: (_content, node) => {
			const element = node as HTMLElement
			const rows = children(element, "color-row")
			const variant =
				element.getAttribute("data-variant") === "table" || rows.length > 0
					? "table"
					: "compact"
			const lines: string[] = [`<Color variant="${variant}">`]
			if (rows.length > 0) {
				for (const row of rows) {
					const titleHtml =
						row.querySelector("[data-color-row-title]")?.innerHTML ?? ""
					const title = titleHtml
						? turndown
								.turndown(titleHtml)
								.replace(/\s*\n\s*/g, " ")
								.trim()
						: ""
					lines.push(`  <Color.Row title="${escapePanelAttribute(title)}">`)
					for (const item of children(row, "color-item")) {
						lines.push(`    ${colorItemMdx(item)}`)
					}
					lines.push("  </Color.Row>")
				}
			} else {
				for (const item of children(element, "color-item")) {
					lines.push(`  ${colorItemMdx(item)}`)
				}
			}
			lines.push("</Color>")
			return `\n\n${lines.join("\n")}\n\n`
		},
	})
}
